"use strict";

export default class CType{

    constructor(){
        this._elements=[];
    }

    setWidth(width){
        this._width=width;
    }

    setHeight(height){
        this._height=height;
    }

    setElements(data){
        let me=this;
        this._data=data;
        this._data.forEach(function (item) {
            me.addElement(item);
        });
    }

    addElement(element){
        this._elements.push(element);
    }

    getElements(){
        return this._elements;
    }

    setConfig(config){
        this._config=config;
    }

    setInputManager(inputManager){
        this._inputManager=inputManager;
    }

}




// WEBPACK FOOTER //
// ./src/components/cchart/CType.js